import { type FC } from 'react';
import { Layer, Source } from 'react-map-gl';
import { nauticalLayer } from '../constants/layers-config';
import { layerSources } from '../constants/constants';
import { externalLinks } from '../../../constants/constants';

const NauticalLayer: FC = () => {
  return (
    <Source id={layerSources.nautical} type="raster" tiles={[externalLinks.openSeaMap]} tileSize={256}>
      <Layer {...nauticalLayer} />
    </Source>
  );
};

export default NauticalLayer;
